import React from 'react';
import Layout from '../../../components/common/pageLayout';
import Form from '../../../components/MasterData/DocumentType/add';
import constant from '../../../constant';
import { toast } from 'react-toastify';
import { v3_add_document_type } from '../../../actions/v3/masterData';

const AddCategory = (props) => {
    const onSubmit = (model) => {
        v3_add_document_type(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message);
                props.history.push(constant.Authedcomponent.listDocumentTypeMasterData.url);
            } else {
                toast.error(res.error);
            }
        });
    };

    return (
        <React.Fragment>
            <Layout title="Add Document Type">
                <Form
                    title="Add Document Type"
                    onSubmit={onSubmit}
                    buttonName="Create Document Type"
                />
            </Layout>
        </React.Fragment>
    );
};

export default AddCategory;
